import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-head-unauth',
  templateUrl: './head-unauth.component.html',
  styleUrls: ['./head-unauth.component.css'],
})
export class HeadUnauthComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
